import React from 'react';
import Image from 'next/image';


const RegistroContador = () => {
    return (
        <>
        <main className="bg-main-image bg-auto" >
	<section >
		<div className="flex flex-col align-center py-20" >
			<span className="font-fredoka text-white text-5xl" >¿Eres Contador?</span>
			<div className="flex flex-wrap justify-center py-4 " >
				<div className="px-4" >
					<Image src="https://cdn.fixat.mx/assets/home/img/028.png" 
					alt="Ayuda Fixat®" 
					title="Ayuda Fixat®"
					height="168px"
					width="168px"
					/>
				</div>

				<div >
					<ul className="text-white font-extrabold text-lg align-top align-left mt-4" >
						<li className="bg-green-check bg-no-repeat mb-2 pl-8">Haz que tus clientes lleguen a ti</li>
						<li className="bg-green-check bg-no-repeat mb-2 pl-8">Trabaja a tus tiempos</li>
						<li className="bg-green-check bg-no-repeat mb-2 pl-8">Gana dinero desde tu casa</li>
						<li className="bg-green-check bg-no-repeat mb-2 pl-8">Trabaja de forma segura</li>
					</ul>
				</div>
			</div>

			<div>
				<p className="text-2xl text-white " >Ponte en contacto con nosotros al correo de <br/>
				hola@fixat.mx</p>
			</div>
		</div>
	</section>
</main>
        </>
    );
}

export default RegistroContador;
